import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import DatePicker from 'react-datepicker'
import {
  Row, Col, Spinner, Badge, Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Label, FormGroup, FormFeedback, Input, Table, CustomInput,
} from 'reactstrap'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import Pqgrid from '../Template/Table/Pqgrid'
import { currencyFormatter, mon2num } from '../../utils/currencyFormatter'
import NewLegalEntity from './NewLegalEntity'
import AddFiles from '../Template/Files/AddFiles'
import AddContractFiles from '../Template/Files/AddContractFiles'
import MaskedInput from '../Template/Input/MaskedInput'
import Select from '../Template/Input/Select'
import AsyncSelect from '../Template/Input/AsyncSelect'
import FormInputTooltip from '../Template/Tooltip/FormInputTooltip'
import { notifyError, notifySuccess } from '../../utils/notify'
import changePosition from '../../utils/array/changePosition'
import { symmetricRound } from '../../utils/fc'
import oikosApi from '../../services/oikos'
import { graphClient } from '../../store/sagas/auth'
import { getLegalEntities } from '../../store/ducks/comercial'
import { getRegs, selectValues, insOrUp, del, getOikosId, getReg, sendMail, getDocs } from '../../utils/fc'


const DEFAULT_CONTRACT = {
  products: [],
  paymentEvents: [],
}

const YES_OR_NOT = [
  {
    label: 'Não',
    value: '0',
  },
  {
    label: 'Sim',
    value: '1',
  },
]

class AddContract extends Component {
  constructor(props) {
    super(props)
    this.state = {
      addContractData: DEFAULT_CONTRACT,
      addContractIsLoading: false,

      addProductModalIsOpen: false,
      addProductData: {},

      editProductModalIsOpen: false,
      editProductData: {},

      deleteProductModalIsOpen: false,

      addPaymentModalIsOpen: false,
      addPaymentData: {},

      addLegalEntityModalIsOpen: false,

      selContrato: false,
      selContratoInst: false,
      selMun: false,
    }

    this.filesRef = React.createRef()
    this.contractFileRef = React.createRef()
    this.trFileRef = React.createRef()
    this.proposalFileRef = React.createRef()
    this.productsGridRef = React.createRef()
    this.paymentEventsGridRef = React.createRef()
  }

  componentDidMount() {
    const { getLegalEntities } = this.props

    getLegalEntities()

    this.preloading()
  }

  preloading = async () => {
    const { contractId } = this.props
    const { addContractData } = this.state
    const contractAux = await getReg('contrato',contractId)
    this.setState({ selContrato: await selectValues('contrato', 'contrato_id', 'contrato_num') }, () => console.log("SelContrato: ", this.state.selContrato))
    this.setState({ selContratoInst: await selectValues('contratoInst', 'contratoInst_id', 'contratoInst_desc') }, () => console.log("selContratoInst: ", this.state.selContratoInst))
    this.setState({ selMun: await selectValues('mun', 'mun_id', 'mun_nome') }, () => console.log("mun: ", this.state.selMun))
    this.setState({ addContractData: { ...addContractData, contractAux, }}, () => console.log("addContractData: ", this.state.addContractData))
  }

  handleAddProduct = () => {
    const { addContractData, addProductData } = this.state

    const product = {
      tempId: uuidv4(),
      order: addContractData.products.length + 1,
      ...addProductData,
    }

    addContractData.products.push(product)

    if (addProductData.hasPaymentEvent) {
      const paymentEvent = {
        tempId: uuidv4(),
        order: addContractData.paymentEvents.length + 1,
        recTp_id: {
          recTp_id: 1,
          recTp_nome: 'Produto',
        },
        contratoEP_desc: addProductData.contratoProd_desc,
        contratoEP_vlr: addProductData.contratoEP_vlr,
        contratoEP_prazo: addProductData.contratoEP_prazo,
        contratoEP_dtPrev: addProductData.contratoEP_dtPrev,
        productId: product.tempId,
      }

      addContractData.paymentEvents.push(paymentEvent)
    }

    this.setState({
      addContractData,
      addProductModalIsOpen: false,
      addProductData: {},
      addPaymentData: {},
    })
  }

  handleEditProduct = () => {
    const { addContractData, editProductData } = this.state

    const index = addContractData.products.findIndex(p => p.tempId === editProductData.tempId)
    addContractData.products[index] = editProductData

    const paymentEventIndex = addContractData.paymentEvents.findIndex(pe => pe.productId === editProductData.tempId)

    if (paymentEventIndex >= 0) {
      if (editProductData.hasPaymentEvent) {
        addContractData.paymentEvents[paymentEventIndex] = {
          ...addContractData.paymentEvents[paymentEventIndex],
          contratoEP_desc: editProductData.contratoProd_desc,
          contratoEP_vlr: editProductData.contratoEP_vlr,
          contratoEP_prazo: editProductData.contratoEP_prazo,
          contratoEP_dtPrev: editProductData.contratoEP_dtPrev,
        }
      } else {
        addContractData.paymentEvents.splice(paymentEventIndex, 1)
      }
    } else if (editProductData.hasPaymentEvent) {
      const paymentEvent = {
        tempId: uuidv4(),
        order: addContractData.paymentEvents.length + 1,
        recTp_id: {
          recTp_id: 1,
          recTp_nome: 'Produto',
        },
        contratoEP_desc: editProductData.contratoProd_desc,
        contratoEP_vlr: editProductData.contratoEP_vlr,
        contratoEP_prazo: editProductData.contratoEP_prazo,
        contratoEP_dtPrev: editProductData.contratoEP_dtPrev,
        productId: editProductData.tempId,
      }

      addContractData.paymentEvents.push(paymentEvent)
    }

    this.setState({
      addContractData,
      editProductModalIsOpen: false,
      editProductData: {},
    })
  }

  handleDeleteProduct = (productIndex) => {
    const { addContractData } = this.state
    const { tempId } = addContractData.products[productIndex]

    const paymentEvents = addContractData.paymentEvents.filter(pe => pe.productId === tempId)

    if (paymentEvents?.length > 0) return this.setState({ deleteProductModalIsOpen: true })

    addContractData.products.splice(productIndex, 1)

    return this.setState({ addContractData })
  }

  handleAddPayment = () => {
    const { addContractData, addPaymentData, addProductData } = this.state

    const paymentEvent = {
      ...addPaymentData,
      tempId: uuidv4(),
      order: addContractData.paymentEvents.length + 1,
    }

    addContractData.paymentEvents.push(paymentEvent)

    this.setState({
      addContractData,
      addPaymentModalIsOpen: false,
      addPaymentData: {},
      addProductData: {
        ...addProductData,
        paymentEvent,
      },
    })
  }

  handleDeletePayment = (paymentIndex) => {
    const { addContractData } = this.state

    addContractData.paymentEvents.splice(paymentIndex, 1)

    this.setState({ addContractData })
  }

  handleProductOrder = (type, index) => {
    const { addContractData } = this.state

    const to = type === 'up'
      ? index - 1
      : type === 'down'
        ? index + 1
        : null

    if (typeof to === 'number') {
      const products = changePosition(addContractData.products, index, to)

      this.setState({
        addContractData: {
          ...addContractData,
          products,
        },
      })
    }

    return null
  }

  handlePaymentEventOrder = (type, index) => {
    const { addContractData } = this.state

    const to = type === 'up'
      ? index - 1
      : type === 'down'
        ? index + 1
        : null

    if (typeof to === 'number') {
      const paymentEvents = changePosition(addContractData.paymentEvents, index, to)

      this.setState({
        addContractData: {
          ...addContractData,
          paymentEvents,
        },
      })
    }

    return null
  }

  checkEventsGlobal = () => {
    const { addContractData } = this.state
    const contractGlobalValue = Number(addContractData.contrato_vlrGlobal) || Number(0)
    const paymentEventsSum = addContractData.paymentEvents.length > 0
      ? Number(addContractData.paymentEvents.map(pe => pe.contratoEP_vlr).reduce((total, current) => Number(total) + Number(current)))
      : 0
    console.log('global =', contractGlobalValue)
    console.log('soma das parcelas =', symmetricRound(paymentEventsSum))
    console.log('diff =', contractGlobalValue !== symmetricRound(paymentEventsSum))
    console.log('parcelas =', addContractData.paymentEvents.length)
    console.log('retorno =', ((addContractData.paymentEvents.length === 0) || contractGlobalValue !== symmetricRound(paymentEventsSum)))

    return ((addContractData.paymentEvents.length > 0) && contractGlobalValue === symmetricRound(paymentEventsSum))
  }

  // eslint-disable-next-line consistent-return
  handleAddContractSubmit = async () => {
    try {
      this.setState({ addContractIsLoading: true })

      const { addContractDataDraft, type, toggle } = this.props
      const { addContractData } = this.state
      const { legalEntities } = this.props.comercial
      const files = this.filesRef?.current?.state?.files
      const contractFile = this.contractFileRef?.current?.state?.files
      const trFile = this.trFileRef?.current?.state?.files
      const proposalFile = this.proposalFileRef?.current?.state?.files

      if (contractFile.length <= 0) {
        notifyError('É necessário anexar o arquivo do contrato antes de confirmar.')
        return this.setState({ addContractIsLoading: false })
      }

      if (proposalFile.length <= 0) {
        notifyError('É necessário anexar o arquivo da proposta antes de confirmar.')
        return this.setState({ addContractIsLoading: false })
      }

      if (addContractData.products.length <= 0) {
        notifyError('É necessário preencher ao menos 1 (um) Produto antes de confirmar.')
        return this.setState({ addContractIsLoading: false })
      }

      const contractGlobalValue = Number(addContractData.contrato_vlrGlobal) || Number(0)

      if (!this.checkEventsGlobal()) {
        notifyError('A soma dos Eventos de Pagamento deve ser igual ao Valor Global do Contrato.')
        return this.setState({ addContractIsLoading: false })
      }

      const contratante = legalEntities.find(p => p.pj_id === addContractDataDraft?.minuta_contratante)
      const contratada = legalEntities.find(p => p.pj_id === addContractDataDraft?.minuta_contratada)

      // Cria um registro na tabela de contratos
      const contractBody = {
        action: 'insert',
        table: 'contrato',
        data: {
          // sp: Number(addContractDataDraft?.SPId) || undefined,
          oport_id: Number(addContractDataDraft?.SPId) || undefined,
          contrato_num: addContractData.contrato_num || undefined,
          contrato_dtProp: addContractData.contrato_dtProp ? moment(addContractData.contrato_dtProp).format('YYYY-MM-DD') : undefined,
          contrato_contratada: addContractDataDraft?.minuta_contratada || undefined,
          contrato_contratante: addContractDataDraft?.minuta_contratante || undefined,
          contrato_obj: addContractData.contrato_obj || undefined,
          contrato_dtAssin: addContractData.contrato_dtAssin ? moment(addContractData.contrato_dtAssin).format('YYYY-MM-DD') : undefined,
          contrato_prazoVigencia: addContractData.contrato_prazoVigencia ? moment(addContractData.contrato_prazoVigencia).format('YYYY-MM-DD') : undefined,
          contrato_prazoExecucao: addContractData.contrato_prazoExecucao ? moment(addContractData.contrato_prazoExecucao).format('YYYY-MM-DD') : undefined,
          contrato_vlrGlobal: contractGlobalValue || undefined,
          contrato_fianca: Number(addContractData.contrato_fianca) || 0,
          contrato_permiteRenovacao: Number(addContractData.contrato_permiteRenovacao) || 0,
          contrato_dtLimFianca: addContractData.contrato_dtLimFianca ? moment(addContractData.contrato_dtLimFianca).format('YYYY-MM-DD') : undefined,
          contrato_indiceReaj: addContractData.contrato_indiceReaj || undefined,
          contrato_dtBaseReaj: addContractData.contrato_dtBaseReaj ? moment(addContractData.contrato_dtBaseReaj).format('YYYY-MM-DD') : undefined,
          contrato_dtAnivReaj: addContractData.contrato_dtAnivReaj ? moment(addContractData.contrato_dtAnivReaj).format('YYYY-MM-DD') : undefined,
          contrato_aguardarOS: addContractData.contrato_aguardarOS || undefined,
          contrato_infoPgto: addContractData.contrato_infoPgto || undefined,
          contrato_obs: addContractData.contrato_obs || undefined,
          minuta_id: addContractDataDraft?.minuta_id || undefined,
          contratoInst_id: addContractDataDraft?.contratoInst_id || undefined,
          contrato_original: addContractDataDraft?.contrato_original || undefined,
          contrato_codTrib: addContractDataDraft?.contrato_codTrib || undefined,
          contrato_aliqISS: addContractDataDraft?.contrato_aliqISS || undefined,
          contrato_munISS: addContractDataDraft?.contrato_munISS || undefined,
        },
      }
      console.tron.log('contractBody', contractBody)
      const contractCreated = await oikosApi.post('/', contractBody)
      console.tron.log('contractCreated', contractCreated)

      // Cria um registro na tabela de documentos
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: 6,
          documento_desc: `Contrato n. ${addContractData.contrato_num} - Contratante ${contratante.pj_nomefanta} x Contratada ${contratada.pj_nomefanta}`,
          documento_iniVig: moment(addContractData.contrato_dtAssin).format('YYYY-MM-DD'),
          documento_fimVig: moment(addContractData.contrato_prazoVigencia).format('YYYY-MM-DD'),
          documento_dtEmissao: moment(addContractData.contrato_dtAssin).format('YYYY-MM-DD'),
          documento_prazo: undefined,
          documento_ref: undefined,
          privacidade_id: 2,
        },
      }
      console.tron.log('documentBody', documentBody)
      const documentCreated = await oikosApi.post('/', documentBody)
      console.tron.log('documentCreated', documentCreated)

      // Cria uma vinculação entre o contrato e a tabela de documentos
      if (documentCreated.data[0].documento_id && contractCreated.data[0].contrato_id) {
        const vinculationBody = {
          action: 'insert',
          table: 'documentoVinc',
          data: {
            documento_id: documentCreated.data[0].documento_id,
            documentoVinc_tabRef: 'contrato',
            documentoVinc_tabId: contractCreated.data[0].contrato_id,
          },
        }
        console.tron.log('vinculationBody', vinculationBody)
        const vinculationCreated = await oikosApi.post('/', vinculationBody)
        console.tron.log('vinculationCreated', vinculationCreated)
      }

      // Cria registros dos produtos e eventos de pagamento
      if (contractCreated.data[0].contrato_id && addContractData.products.length > 0) {
        await Promise.all(addContractData.products.map(async (product) => {
          const productBody = {
            action: 'insert',
            table: 'contratoProd',
            data: {
              contrato_id: contractCreated.data[0].contrato_id,
              contratoProd_desc: product.contratoProd_desc,
              contratoProd_prazo: product.contratoProd_prazo,
              contratoProd_dtPrev: product.contratoProd_dtPrev ? moment(product.contratoProd_dtPrev).format('YYYY-MM-DD') : undefined,
              contratoProd_ord: addContractData.products.indexOf(product) + 1,
            },
          }
          console.tron.log('productBody', productBody)
          const productCreated = await oikosApi.post('/', productBody)
          console.tron.log('productCreated', productCreated)

          const paymentEvents = addContractData.paymentEvents.filter(pe => pe.productId === product.tempId)
          console.tron.log(`paymentEvents product ${productCreated.data[0].contratoProd_id}`, paymentEvents)
          if (paymentEvents && paymentEvents.length > 0) {
            await Promise.all(paymentEvents.map(async (paymentEvent) => {
              const paymentEventBody = {
                action: 'insert',
                table: 'contratoEP',
                data: {
                  contrato_id: contractCreated.data[0].contrato_id,
                  contratoProd_id: productCreated.data[0].contratoProd_id,
                  contratoEP_desc: paymentEvent.contratoEP_desc,
                  contratoEP_prazo: paymentEvent.contratoEP_prazo,
                  contratoEP_dtPrev: paymentEvent.contratoEP_dtPrev ? moment(paymentEvent.contratoEP_dtPrev).format('YYYY-MM-DD') : undefined,
                  contratoEP_vlr: Number(paymentEvent.contratoEP_vlr),
                  contratoEP_ord: addContractData.paymentEvents.indexOf(paymentEvent) + 1,
                  recTp_id: paymentEvent.recTp_id.recTp_id,
                },
              }
              console.tron.log('paymentEventBody', paymentEventBody)
              const paymentEventCreated = await oikosApi.post('/', paymentEventBody)
              console.tron.log('paymentEventCreated', paymentEventCreated)
            }))
          }
        }))
      }

      // Cria registros dos eventos de pagamento que não estão vinculados à nenhum produto
      const paymentEventsWithoutProducts = addContractData.paymentEvents.filter(pe => !pe.productId)
      console.tron.log('paymentEventsWithoutProducts', paymentEventsWithoutProducts)
      if (paymentEventsWithoutProducts?.length > 0) {
        await Promise.all(paymentEventsWithoutProducts.map(async paymentEvent => {
          const paymentEventBody = {
            action: 'insert',
            table: 'contratoEP',
            data: {
              contrato_id: contractCreated.data[0].contrato_id,
              contratoProd_id: undefined,
              contratoEP_desc: paymentEvent.contratoEP_desc,
              contratoEP_prazo: paymentEvent.contratoEP_prazo,
              contratoEP_dtPrev: paymentEvent.contratoEP_dtPrev ? moment(paymentEvent.contratoEP_dtPrev).format('YYYY-MM-DD') : undefined,
              contratoEP_vlr: Number(paymentEvent.contratoEP_vlr),
              contratoEP_ord: addContractData.paymentEvents.indexOf(paymentEvent) + 1,
              recTp_id: paymentEvent.recTp_id.recTp_id,
            },
          }
          console.tron.log('paymentEventBody', paymentEventBody)
          const paymentEventCreated = await oikosApi.post('/', paymentEventBody)
          console.tron.log('paymentEventCreated', paymentEventCreated)
        }))
      }

      // Faz upload do pdf do contrato
      if (contractFile.length > 0) {
        const formData = new FormData()
        formData.append('file', new Blob([contractFile[0].data], { type: contractFile[0].data.type }), contractFile[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', contractFile[0].data.path)

        const res = await oikosApi.post('/', formData)
        console.tron.log('res upload_file', res)
      }

      // Faz upload do pdf da proposta comercial
      if (proposalFile.length > 0) {
        // Cria um registro na tabela de documentos
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: 21,
            documento_desc: 'Proposta Comercial',
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre a proposta comercial e o contrato
        if (documentCreated.data[0].documento_id && contractCreated.data[0].contrato_id) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'contrato',
              documentoVinc_tabId: contractCreated.data[0].contrato_id,
            },
          }
          await oikosApi.post('/', vinculationBody)
        }

        const formData = new FormData()
        formData.append('file', new Blob([proposalFile[0].data], { type: proposalFile[0].data.type }), proposalFile[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', proposalFile[0].data.path)

        const res = await oikosApi.post('/', formData)
        console.tron.log('res upload_file', res)
      }

      // Faz upload do pdf do termo de referência
      if (trFile.length > 0) {
        // Cria um registro na tabela de documentos
        const documentBody = {
          action: 'insert',
          table: 'documento',
          data: {
            tpDocumento_id: 22,
            documento_desc: 'Termo de Referência - TR',
            documento_iniVig: undefined,
            documento_fimVig: undefined,
            documento_dtEmissao: undefined,
            documento_prazo: undefined,
            documento_ref: undefined,
            privacidade_id: 2,
          },
        }
        const documentCreated = await oikosApi.post('/', documentBody)

        // Cria uma vinculação entre o termo de referência e o contrato
        if (documentCreated.data[0].documento_id && contractCreated.data[0].contrato_id) {
          const vinculationBody = {
            action: 'insert',
            table: 'documentoVinc',
            data: {
              documento_id: documentCreated.data[0].documento_id,
              documentoVinc_tabRef: 'contrato',
              documentoVinc_tabId: contractCreated.data[0].contrato_id,
            },
          }
          await oikosApi.post('/', vinculationBody)
        }

        const formData = new FormData()
        formData.append('file', new Blob([trFile[0].data], { type: trFile[0].data.type }), trFile[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', trFile[0].data.path)

        const res = await oikosApi.post('/', formData)
        console.tron.log('res upload_file', res)
      }

      // Faz upload dos anexos gerais
      if (files.length > 0) {
        await Promise.all(files.map(async file => {
          // Cria um registro na tabela de documentos para cada arquivo
          const documentBody = {
            action: 'insert',
            table: 'documento',
            data: {
              tpDocumento_id: file.props?.documentType?.tpDocumento_id,
              documento_desc: file.props?.description,
              documento_iniVig: undefined,
              documento_fimVig: undefined,
              documento_dtEmissao: undefined,
              documento_prazo: undefined,
              documento_ref: undefined,
              privacidade_id: 2,
            },
          }
          const documentCreated = await oikosApi.post('/', documentBody)

          // Cria uma vinculação entre o documento (anexo) e o contrato
          if (documentCreated.data[0].documento_id && contractCreated.data[0].contrato_id) {
            const vinculationBody = {
              action: 'insert',
              table: 'documentoVinc',
              data: {
                documento_id: documentCreated.data[0].documento_id,
                documentoVinc_tabRef: 'contrato',
                documentoVinc_tabId: contractCreated.data[0].contrato_id,
              },
            }
            await oikosApi.post('/', vinculationBody)
          }

          // Faz upload do arquivo e registra na tabela 'arquivo'
          const formData = new FormData()
          formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
          formData.append('table', 'arquivo')
          formData.append('action', 'upload_file')
          formData.append('arquivo_tabRef', 'documento')
          formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
          formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
          formData.append('arquivo_desc', file.data.path)
          const fileUploadRes = await oikosApi.post('/', formData)
          console.tron.log('fileUploadRes', fileUploadRes)
        }))
      }

      // Atualiza status da oportunidade/licitação no SharePoint para Contratada
      if (type === 'privado') {
        const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,ab4a25d0-22db-487b-a5b6-4da8e59bd13c'
        const listId = '24e2b5f2-3b68-40f3-96a8-d154f82986d1'
        const itemId = addContractDataDraft.SPId
        const opportunityUpdated = await graphClient
          .api(`/sites/${siteId}/lists/${listId}/items/${itemId}/fields`)
          .update({
            Status0: 'Contratada',
            Status: 'Ganho',
            Datacontratada: moment().format('YYYY-MM-DDThh:mm:ss[Z]'),
          })
        console.tron.log('opportunityUpdated', opportunityUpdated)
      } else if (type === 'publico') {
        const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,32cf4926-8ed5-475c-918f-6b48d3e42b49'
        const listId = 'df3f359b-f817-44b5-a140-e384223bf177'
        const itemId = addContractDataDraft.SPId
        const opportunityUpdated = await graphClient
          .api(`/sites/${siteId}/lists/${listId}/items/${itemId}/fields`)
          .update({
            Situa_x00e7__x00e3_o: 'Contratada',
          })
        console.tron.log('opportunityUpdated', opportunityUpdated)
      }
      // Cria registro do contrato na lista do sharepoint
      await fetch('https://oikos.ecoss.is/oikos/_webhook_oikos2sp_contracts.php')
      sendMail('gerencia.tecnico@ecossis.com.br', 'Contrato ' + addContractData.contrato_num + ' cadastrado no Oikos', addContractData.contrato_obj, 'oikos@ecossis.com.br')
      notifySuccess('Contrato cadastrado com sucesso.')
      this.setState({
        addContractIsLoading: false,
        addContractData: DEFAULT_CONTRACT,
        addProductData: {},
        addPaymentData: {},

      })
      toggle()
    } catch (e) {
      notifyError('Não foi possível cadastrar o contrato.')
      console.tron.log('Não foi possível cadastrar o contrato.', e)
      this.setState({ addContractIsLoading: false })
    }
  }

  render() {
    const {
      isOpen, toggle, addContractDataDraft, type, contractId,
    } = this.props

    const {
      addContractIsLoading, addContractData,
      addProductModalIsOpen, addProductData, deleteProductModalIsOpen,
      addPaymentModalIsOpen, addPaymentData,
      editProductModalIsOpen, editProductData,
      addLegalEntityModalIsOpen,
      selContrato, selContratoInst, selMun,
    } = this.state

    let {
      legalEntities,
    } = this.props.comercial

    legalEntities = legalEntities?.map(i => ({
      value: i.pj_id,
      label: i.pj_nomefanta,
    }))

    console.log('addContractDataDraft', addContractDataDraft)
    console.log('contractId = ', contractId)
    console.tron.log('addContractData', addContractData)
    console.tron.log('addProductData', addProductData)
    console.tron.log('addPaymentData', addPaymentData)
    console.tron.log('this.productsGridRef.current.state', this.productsGridRef?.current?.state)

    return (
      <>
        <NewLegalEntity
          isOpen={addLegalEntityModalIsOpen}
          toggle={id => {
            this.setState({
              addContractData: {
                ...addContractData,
                contrato_contratante: id,
              },
              addLegalEntityModalIsOpen: false,
            })

            this.props.getLegalEntities()
          }}
        />

        <Modal
          size="lg"
          isOpen={isOpen}
        >
          <ModalHeader>
            Cadastrar Contrato - {addContractData.contrato_contratante} - {addContractData.contrato_num}
          </ModalHeader>
          <ModalBody>
            <Row style={{ marginTop: -12 }}>
              <Col>
                <Tabs>
                  <TabList>
                    <Tab>Geral</Tab>
                    <Tab>Produtos</Tab>
                    <Tab>Eventos de Pagamento</Tab>
                    <Tab>Anexos</Tab>
                  </TabList>

                  <TabPanel forceRender>
                    <Row>
                      <Col sm={4}>
                        <FormGroup>
                          <div className="d-flex align-items-center" style={{ marginBottom: -4 }}>
                            <Label>
                              Nº Contrato
                            </Label>
                            <FormInputTooltip
                              text="Na ausência de Contrato preencher com o nº da proposta, nº da OS ou nº do edital."
                            />
                          </div>
                          <Input
                            invalid={addContractData.contrato_num_Invalid}
                            value={addContractData.contrato_num}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_num: e.target.value || null,
                                contrato_num_Invalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Quem assinou o contrato
                          </Label>

                          <AsyncSelect
                            cacheOptions
                            defaultOptions
                            isSearchable={false}
                            isClearable={false}
                            isMulti={false}
                            getOptionValue={option => option.pf_id}
                            getOptionLabel={option => option.pf_nomeExibicao}
                            value={addContractData.contrato_assinante}
                            loadOptions={async () => {
                              try {
                                const res = await oikosApi.get('/', {
                                  action: 'get',
                                  table: 'pf',
                                })

                                if (addContractData.contrato_assinante !== undefined) {
                                  this.setState(prevState => ({
                                    addContractData: {
                                      ...prevState.addContractData,
                                      contrato_assinante: res.data.find(i => i.pf_id === addContractData.contrato_assinante.pf_id),
                                    },
                                  }))
                                }

                                return res.data.filter(item => item.pf_nomeExibicao === 'Gustavo Leite' || item.pf_nomeExibicao === 'Juliano Moreira' || item.pf_nomeExibicao === 'Bernardo Alcalde')
                              } catch (e) {
                                return notifyError(e)
                              }
                            }}
                            onChange={e => this.setState(prevState => ({
                              addContractData: {
                                ...prevState.addContractData,
                                contrato_assinante: e,
                              },
                            }))}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Data da proposta
                          </Label>
                          <DatePicker
                            placeholderText="__/__/_____"
                            locale="pt-BR"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={
                              addContractData?.contrato_dtProp
                                ? moment(addContractData.contrato_dtProp).toDate()
                                : addContractDataDraft?.fields?.zlir
                                  ? moment(addContractDataDraft.fields.zlir).toDate()
                                  : addContractDataDraft?.fields?.Abertura
                                    ? moment(addContractDataDraft.fields.Abertura).toDate()
                                    : null
                            }
                            onChange={date => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_dtProp: date,
                                contrato_dtProp_Invalid: false,
                              },
                            })}
                          />
                          <FormFeedback invalid={addContractData.contrato_dtProp_Invalid}>
                            Campo obrigatório.
                          </FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                      <FormGroup>
                          <Label>
                            Alteração contratual
                          </Label>
                          <Select
                            classNamePrefix="select2-selection"
                            placeholder="Selecionar..."
                            value={selContratoInst && selContratoInst?.filter(x => (x.value === addContractData.contratoInst_id))}
                            options={selContratoInst || []}
                            //isDisabled={!selContratoInst || modalData.task_id}
                            isLoading={!selContratoInst}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contratoInst_id: e.value,
                                contratoInst_id_Invalid: false,
                              }
                            })}
                          />

                          <FormFeedback invalid={addContractData.contratoInst_id_Invalid}>
                            Campo obrigatório.
                          </FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={8}>
                        <FormGroup>
                          <Label>
                            Contrato original
                          </Label>
                          <Select
                            isClearable
                            isSearchable
                            value={selContrato && selContrato?.filter(x => (x.value === addContractData.contrato_original))}
                            options={selContrato || []}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_original: e?.value,
                                contrato_original_Invalid: false,
                              },
                            })}
                          />
                          <FormFeedback invalid={addContractData.contrato_original_Invalid}>
                            Campo obrigatório.
                          </FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={6}>
                        <FormGroup>
                          <Label>
                            Contratante
                          </Label>

                          <Select
                            isDisabled
                            value={legalEntities?.filter(p => p.value === (
                              addContractDataDraft?.minuta_contratante
                            ))}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={6}>
                        <FormGroup>
                          <Label>
                            Contratada
                          </Label>
                          <Select
                            isDisabled
                            value={legalEntities?.filter(p => p.value === (
                              addContractDataDraft?.minuta_contratada
                            ))}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={12}>
                        <FormGroup>
                          <div className="d-flex align-items-center" style={{ marginBottom: -4 }}>
                            <Label>
                              Objeto do contrato
                            </Label>
                            <FormInputTooltip
                              text="Objeto tal e qual está no contrato ou descrição sumária."
                            />
                          </div>
                          <Input
                            invalid={addContractData.contrato_obj_Invalid}
                            type="textarea"
                            rows={2}
                            value={addContractData.contrato_obj}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_obj: e.target.value || null,
                                contrato_obj_Invalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Data da assinatura
                          </Label>
                          <DatePicker
                            placeholderText="__/__/_____"
                            locale="pt-BR"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={addContractData?.contrato_dtAssin ? moment(addContractData.contrato_dtAssin).toDate() : null}
                            onChange={date => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_dtAssin: date,
                                contrato_dtAssin_Invalid: false,
                              },
                            })}
                          />
                          <FormFeedback invalid={addContractData.contrato_dtAssin_Invalid}>
                            Campo obrigatório.
                          </FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Fim do prazo de vigência
                          </Label>
                          <DatePicker
                            placeholderText="__/__/_____"
                            locale="pt-BR"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={addContractData?.contrato_prazoVigencia ? moment(addContractData.contrato_prazoVigencia).toDate() : null}
                            onChange={date => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_prazoVigencia: date,
                                contrato_prazoVigencia_Invalid: false,
                              },
                            })}
                          />
                          <FormFeedback invalid={addContractData.contrato_prazoVigencia_Invalid}>
                            Campo obrigatório.
                          </FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Fim do prazo de execução
                          </Label>
                          <DatePicker
                            placeholderText="__/__/_____"
                            locale="pt-BR"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={addContractData?.contrato_prazoExecucao ? moment(addContractData.contrato_prazoExecucao).toDate() : null}
                            onChange={date => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_prazoExecucao: date,
                                contrato_prazoExecucao_Invalid: false,
                              },
                            })}
                          />
                          <FormFeedback invalid={addContractData.contrato_prazoExecucao_Invalid}>
                            Campo obrigatório.
                          </FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Valor global
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputVlrGlobal = el}
                            mask="R$ num"
                            blocks={{
                              num: {
                                mask: Number,
                                scale: 2, // digits after point 0 for integers
                                signed: false, // disallow negative
                                thousandsSeparator: '.', // any single char
                                padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                                normalizeZeros: false, // appends or removes zeros at ends
                                radix: ',', // fractional delimiter
                                min: 0,
                                max: 1000000000,
                              },
                            }}
                            lazy={false}
                            value={addContractData.contrato_vlrGlobal}
                            onAccept={value => { this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_vlrGlobal: value,
                                contrato_vlrGlobal_Invalid: false,
                              },
                            })
                            console.log('res fc',this.checkEventsGlobal())
                            }}
                            invalid={addContractData.contrato_vlrGlobal && !this.checkEventsGlobal()}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Fiança
                          </Label>
                          <Select
                            isClearable
                            isSearchable
                            options={YES_OR_NOT}
                            value={YES_OR_NOT.filter(t => t.value === (addContractData?.contrato_fianca ? addContractData.contrato_fianca : null))}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_fianca: e?.value,
                                contrato_fianca_Invalid: false,
                                contrato_dtLimFianca: null,
                                contrato_dtLimFianca_Invalid: false,
                              },
                            })}
                          />
                          <FormFeedback invalid={addContractData.contrato_fianca_Invalid}>
                            Campo obrigatório.
                          </FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Data limite da fiança
                          </Label>
                          <DatePicker
                            disabled={
                              !addContractData.contrato_fianca
                              || addContractData.contrato_fianca === '0'
                            }
                            placeholderText="__/__/_____"
                            locale="pt-BR"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={addContractData?.contrato_dtLimFianca ? moment(addContractData.contrato_dtLimFianca).toDate() : null}
                            onChange={date => this.setState({ addContractData: { ...addContractData, contrato_dtLimFianca: date } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Índice de reajuste
                          </Label>
                          <Input
                            value={addContractData.contrato_indiceReaj}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_indiceReaj: e.target.value || null,
                              },
                            })}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Data base do reajuste
                          </Label>
                          <DatePicker
                            placeholderText="__/__/_____"
                            locale="pt-BR"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={addContractData?.contrato_dtBaseReaj ? moment(addContractData.contrato_dtBaseReaj).toDate() : null}
                            onChange={date => this.setState({ addContractData: { ...addContractData, contrato_dtBaseReaj: date } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Data de aniv. do reajuste
                          </Label>
                          <DatePicker
                            placeholderText="__/__/_____"
                            locale="pt-BR"
                            className="form-control"
                            dateFormat="dd/MM/yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            selected={addContractData?.contrato_dtAnivReaj ? moment(addContractData.contrato_dtAnivReaj).toDate() : null}
                            onChange={date => this.setState({ addContractData: { ...addContractData, contrato_dtAnivReaj: date } })}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Possibilidade de aditivo?
                          </Label>
                          <Select
                            isClearable
                            isSearchable
                            options={YES_OR_NOT}
                            value={YES_OR_NOT.filter(t => t.value === addContractData?.contrato_permiteRenovacao)}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_permiteRenovacao: e?.value,
                              },
                            })}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Haverá emissão de OS?
                          </Label>
                          <Select
                            isClearable
                            isSearchable
                            options={YES_OR_NOT}
                            value={YES_OR_NOT.filter(t => t.value === (addContractData?.contrato_aguardarOS ? addContractData.contrato_aguardarOS : null))}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_aguardarOS: e?.value,
                              },
                            })}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Informações de pagamento
                          </Label>
                          <Input
                            invalid={addContractData.contrato_infoPgto_Invalid}
                            value={addContractData.contrato_infoPgto}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_infoPgto: e.target.value || null,
                                contrato_infoPgto_Invalid: false,
                              },
                            })}
                          />
                          <FormFeedback>Campo obrigatório.</FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Código Tributário
                          </Label>
                          <Input
                            value={addContractData.contrato_codTrib}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_codTrib: e.target.value || null,
                              },
                            })}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Alíquota de ISSQN
                          </Label>
                          <MaskedInput
                            unmask
                            inputRef={el => this.inputAliqISS = el}
                            mask="% num"
                            blocks={{
                              num: {
                                mask: Number,
                                scale: 2, // digits after point 0 for integers
                                signed: false, // disallow negative
                                thousandsSeparator: '.', // any single char
                                padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                                normalizeZeros: false, // appends or removes zeros at ends
                                radix: ',', // fractional delimiter
                                min: 0,
                                max: 5,
                              },
                            }}
                            lazy={false}
                            value={addContractData.contrato_aliqISS}
                            onAccept={value => { this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_aliqISS: value,
                                contrato_aliqISS_Invalid: false,
                              },
                            })
                            }}
                            invalid={addContractData.contrato_aliqISS_Invalid}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label>
                            Município de Recolhimento do ISS
                          </Label>
                          <Select
                            isClearable
                            isSearchable
                            value={selMun && selMun?.filter(x => (x.value === addContractData.contrato_munISS))}
                            options={selMun || []}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_munISS: e?.value,
                                contrato_munISS_Invalid: false,
                              },
                            })}
                          />
                          <FormFeedback invalid={addContractData.contrato_fianca_Invalid}>
                            Campo obrigatório.
                          </FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col sm={12}>
                        <FormGroup>
                          <Label>
                            Observações gerais
                          </Label>
                          <Input
                            type="textarea"
                            rows={2}
                            value={addContractData.contrato_obs}
                            onChange={e => this.setState({
                              addContractData: {
                                ...addContractData,
                                contrato_obs: e.target.value || null,
                              },
                            })}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label className="font-weight-bold">
                            Contrato
                          </Label>
                          <AddFiles
                            drop={false}
                            multiple={false}
                            ref={this.contractFileRef}
                            accept={['.pdf']}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label className="font-weight-bold">
                            Proposta comercial
                          </Label>
                          <AddFiles
                            drop={false}
                            multiple={false}
                            ref={this.proposalFileRef}
                            accept={['.pdf']}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={4}>
                        <FormGroup>
                          <Label className="font-weight-bold">
                            Termo de Referência
                          </Label>
                          <AddFiles
                            drop={false}
                            multiple={false}
                            ref={this.trFileRef}
                            accept={['.pdf']}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </TabPanel>

                  <TabPanel>
                    <Row>
                      <Col>
                        <Label>
                          Produtos
                        </Label>
                      </Col>

                      <Col className="d-flex justify-content-end">
                        <Button
                          size="sm"
                          color="link"
                          className="mb-1 px-0"
                          onClick={() => this.setState({
                            addProductModalIsOpen: true,
                            addProductData: {},
                          })}
                        >
                          Adicionar
                        </Button>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div className="table-responsive">
                          <Table striped bordered>
                            <thead>
                              <tr>
                                <th>Ordem</th>
                                <th>Descrição</th>
                                <th>Prazo de entrega</th>
                                <th>Data de entrega prevista</th>
                                <th>Evento de Pagamento</th>
                                <th>Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              {addContractData?.products?.length > 0 && (
                                <>
                                  {addContractData.products.map((product, index) => (
                                    <tr>
                                      <td>
                                        {index + 1}
                                      </td>
                                      <td>
                                        {product.contratoProd_desc}
                                      </td>
                                      <td>
                                        {product.contratoProd_prazo}
                                      </td>
                                      <td>
                                        {moment(product.contratoProd_dtPrev).format('DD/MM/YYYY')}
                                      </td>
                                      <td>
                                        {
                                          product.hasPaymentEvent
                                            ? addContractData.paymentEvents?.find(pe => pe.productId === product.tempId)
                                              ? 'Sim'
                                              : <div className="d-flex">Sim <Badge className="badge-soft-danger ml-1">Pendente</Badge></div>
                                            : 'Não'
                                        }
                                      </td>
                                      <td>
                                        <div className="d-flex">
                                          <Button
                                            title="Mover para cima"
                                            disabled={index === 0}
                                            style={{ width: 30.6, height: 30.9 }}
                                            color="light"
                                            size="sm"
                                            onClick={() => this.handleProductOrder('up', index)}
                                          >
                                            <i className="ri-arrow-up-s-line" />
                                          </Button>

                                          <Button
                                            title="Mover para baixo"
                                            disabled={index + 1 >= addContractData.products.length}
                                            className="ml-2"
                                            style={{ width: 30.6, height: 30.9 }}
                                            color="light"
                                            size="sm"
                                            onClick={() => this.handleProductOrder('down', index)}
                                          >
                                            <i className="ri-arrow-down-s-line" />
                                          </Button>

                                          <Button
                                            title="Editar"
                                            className="ml-2"
                                            color="light"
                                            size="sm"
                                            onClick={() => this.setState({
                                              editProductData: product,
                                              editProductModalIsOpen: true,
                                            })}
                                          >
                                            <i className="ri-pencil-fill" />
                                          </Button>

                                          <Button
                                            title="Excluir"
                                            className="ml-2"
                                            color="light"
                                            size="sm"
                                            onClick={() => this.handleDeleteProduct(index)}
                                          >
                                            <i className="ri-delete-bin-6-line" />
                                          </Button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              )}
                            </tbody>
                          </Table>
                          {addContractData?.products?.length <= 0 && (
                            <span className="mt-2 mb-2 d-flex">
                              Nenhum produto cadastrado.
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </TabPanel>

                  <TabPanel>
                    <Row>
                      <Col>
                        <Label>
                          Eventos de pagamento
                        </Label>
                      </Col>

                      <Col className="d-flex justify-content-end">
                        <Button
                          size="sm"
                          color="link"
                          className="mb-1 px-0"
                          onClick={() => this.setState({
                            addPaymentModalIsOpen: true,
                            addPaymentData: {},
                          })}
                        >
                          Adicionar
                        </Button>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div className="table-responsive">
                          <Table striped bordered>
                            <thead>
                              <tr>
                                <th>Ordem</th>
                                <th>Tipo</th>
                                <th>Descrição</th>
                                <th>Valor</th>
                                <th>Prazo de pagamento</th>
                                <th>Data de pagamento prevista</th>
                                <th>Ações</th>
                              </tr>
                            </thead>
                            {addContractData?.paymentEvents?.length > 0 && (
                              <>
                                <tbody>
                                  {addContractData.paymentEvents.map((payment, index) => (
                                    <tr>
                                      <td>
                                        {index + 1}
                                      </td>
                                      <td>
                                        {payment.recTp_id.recTp_nome}
                                      </td>
                                      <td>
                                        {payment.contratoEP_desc}
                                      </td>
                                      <td>
                                        {currencyFormatter.format(payment.contratoEP_vlr)}
                                      </td>
                                      <td>
                                        {payment.contratoEP_prazo}
                                      </td>
                                      <td>
                                        {moment(payment.contratoEP_dtPrev).format('DD/MM/YYYY')}
                                      </td>
                                      <td>
                                        <div className="d-flex">
                                          <Button
                                            title="Mover para cima"
                                            disabled={index === 0}
                                            style={{ width: 30.6, height: 30.9 }}
                                            color="light"
                                            size="sm"
                                            onClick={() => this.handlePaymentEventOrder('up', index)}
                                          >
                                            <i className="ri-arrow-up-s-line" />
                                          </Button>

                                          <Button
                                            title="Mover para baixo"
                                            disabled={index + 1 >= addContractData.paymentEvents.length}
                                            className="ml-2"
                                            style={{ width: 30.6, height: 30.9 }}
                                            color="light"
                                            size="sm"
                                            onClick={() => this.handlePaymentEventOrder('down', index)}
                                          >
                                            <i className="ri-arrow-down-s-line" />
                                          </Button>

                                          <Button
                                            title="Excluir"
                                            className="ml-2"
                                            color="light"
                                            size="sm"
                                            onClick={() => this.handleDeletePayment(index)}
                                          >
                                            <i className="ri-delete-bin-6-line" />
                                          </Button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td>Total</td>
                                    <td />
                                    <td />
                                    <td>
                                      {
                                        currencyFormatter
                                          .format(addContractData.paymentEvents
                                            .map(pe => pe.contratoEP_vlr)
                                            .reduce((total, current) => Number(total) + Number(current)))
                                      }
                                    </td>
                                    <td />
                                    <td />
                                    <td />
                                  </tr>
                                </tfoot>
                              </>
                            )}
                          </Table>
                          {addContractData?.paymentEvents?.length <= 0 && (
                            <span className="mt-2 mb-2 d-flex">
                              Nenhum evento de pagamento cadastrado.
                            </span>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </TabPanel>

                  <TabPanel forceRender>
                    <AddContractFiles
                      ref={this.filesRef}
                    />
                  </TabPanel>
                </Tabs>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => {
                this.setState({
                  addContractData: DEFAULT_CONTRACT,
                  addProductData: {},
                  addPaymentData: {},
                })
                toggle()
              }}
              color="light"
              className="waves-effect"
              disabled={addContractIsLoading}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => this.handleAddContractSubmit()}
              disabled={
                addContractIsLoading
                || !addContractData
                || !addContractData.contrato_num
                || !addContractData.contrato_obj || !addContractData.contrato_dtAssin
                || !addContractData.contrato_prazoVigencia || !addContractData.contrato_prazoExecucao
                || !addContractData.contrato_vlrGlobal || !addContractData.contrato_fianca
                || (addContractData.contrato_fianca === '1' && !addContractData.contrato_dtLimFianca)
                || !addContractData.contrato_aguardarOS
                || (
                  !addContractData.contrato_dtProp
                  && !addContractDataDraft?.fields?.zlir
                  && !addContractDataDraft?.fields?.Abertura
                )
              }
            >
              Confirmar
              {addContractIsLoading && (
                <Spinner size="sm" className="ml-2" />
              )}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          centered={false}
          isOpen={addProductModalIsOpen}
          toggle={() => this.setState({ addProductData: {}, addProductModalIsOpen: false })}
        >
          <ModalHeader
            toggle={() => this.setState({
              addProductData: {},
              addProductModalIsOpen: false,
            })}
          >
            Adicionar produto
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                Descrição
              </Label>
              <Input
                value={addProductData?.contratoProd_desc}
                onChange={e => this.setState({
                  addProductData: {
                    ...addProductData,
                    contratoProd_desc: e.target.value || null,
                  },
                })}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                Prazo de entrega
              </Label>
              <Input
                value={addProductData?.contratoProd_prazo}
                onChange={e => this.setState({
                  addProductData: {
                    ...addProductData,
                    contratoProd_prazo: e.target.value || null,
                  },
                })}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                Data de entrega prevista
              </Label>

              <DatePicker
                placeholderText="__/__/_____"
                locale="pt-BR"
                className="form-control"
                dateFormat="dd/MM/yyyy"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={addProductData?.contratoProd_dtPrev ? moment(addProductData.contratoProd_dtPrev).toDate() : null}
                onChange={date => this.setState({
                  addProductData: {
                    ...addProductData,
                    contratoProd_dtPrev: date,
                    contratoProd_dtPrev_Invalid: false,
                  },
                })}
              />
            </FormGroup>

            <Row>
              <Col>
                <hr />
              </Col>
            </Row>

            <Row className="mb-2 mt-2">
              <Col>
                <Label>
                  Possui evento de pagamento
                </Label>
              </Col>

              <Col className="d-flex justify-content-end">
                <CustomInput
                  type="switch"
                  id="hasPaymentEvent"
                  onChange={e => this.setState({
                    addProductData: {
                      ...addProductData,
                      hasPaymentEvent: e?.target?.checked,
                    },
                  })}
                />
              </Col>
            </Row>

            {addProductData.hasPaymentEvent && (
              <>
                <FormGroup>
                  <Label>
                    Valor
                  </Label>
                  <MaskedInput
                    unmask
                    mask="R$ num"
                    blocks={{
                      num: {
                        mask: Number,
                        scale: 2, // digits after point 0 for integers
                        signed: false, // disallow negative
                        thousandsSeparator: '.', // any single char
                        padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                        normalizeZeros: false, // appends or removes zeros at ends
                        radix: ',', // fractional delimiter
                        min: 0,
                        max: 1000000000,
                      },
                    }}
                    lazy={false}
                    value={addProductData.contratoEP_vlr}
                    onAccept={value => this.setState({
                      addProductData: {
                        ...addProductData,
                        contratoEP_vlr: value,
                      },
                    })}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Prazo de pagamento
                  </Label>
                  <Input
                    value={addProductData?.contratoEP_prazo}
                    onChange={e => this.setState({
                      addProductData: {
                        ...addProductData,
                        contratoEP_prazo: e.target.value || null,
                      },
                    })}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data de pagamento prevista
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.contratoEP_dtPrev ? moment(addProductData.contratoEP_dtPrev).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        contratoEP_dtPrev: date,
                        contratoEP_dtPrev_Invalid: false,
                      },
                    })}
                  />
                </FormGroup>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.setState({ addProductData: {}, addProductModalIsOpen: false })}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => this.handleAddProduct()}
              disabled={
                !addProductData?.contratoProd_desc
                || !addProductData?.contratoProd_prazo
                || !addProductData?.contratoProd_dtPrev
                || (addProductData.hasPaymentEvent && (!addProductData?.contratoEP_vlr || !addProductData?.contratoEP_prazo || !addProductData?.contratoEP_dtPrev))
              }
            >
              Adicionar
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          centered={false}
          isOpen={editProductModalIsOpen}
          toggle={() => this.setState({ editProductData: {}, editProductModalIsOpen: false })}
        >
          <ModalHeader
            toggle={() => this.setState({
              editProductData: {},
              editProductModalIsOpen: false,
            })}
          >
            Editar produto
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                Descrição
              </Label>
              <Input
                value={editProductData?.contratoProd_desc}
                onChange={e => this.setState({
                  editProductData: {
                    ...editProductData,
                    contratoProd_desc: e.target.value || null,
                  },
                })}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                Prazo de entrega
              </Label>
              <Input
                value={editProductData?.contratoProd_prazo}
                onChange={e => this.setState({
                  editProductData: {
                    ...editProductData,
                    contratoProd_prazo: e.target.value || null,
                  },
                })}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                Data de entrega prevista
              </Label>

              <DatePicker
                placeholderText="__/__/_____"
                locale="pt-BR"
                className="form-control"
                dateFormat="dd/MM/yyyy"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={editProductData?.contratoProd_dtPrev ? moment(editProductData.contratoProd_dtPrev).toDate() : null}
                onChange={date => this.setState({
                  editProductData: {
                    ...editProductData,
                    contratoProd_dtPrev: date,
                    contratoProd_dtPrev_Invalid: false,
                  },
                })}
              />
            </FormGroup>

            <Row>
              <Col>
                <hr />
              </Col>
            </Row>

            <Row className="mb-2 mt-2">
              <Col>
                <Label>
                  Possui evento de pagamento
                </Label>
              </Col>

              <Col className="d-flex justify-content-end">
                <CustomInput
                  type="switch"
                  id="hasPaymentEvent"
                  checked={editProductData.hasPaymentEvent}
                  onChange={e => this.setState({
                    editProductData: {
                      ...editProductData,
                      hasPaymentEvent: e?.target?.checked,
                    },
                  })}
                />
              </Col>
            </Row>

            {editProductData.hasPaymentEvent && (
              <>
                <FormGroup>
                  <Label>
                    Valor
                  </Label>
                  <MaskedInput
                    unmask
                    mask="R$ num"
                    blocks={{
                      num: {
                        mask: Number,
                        scale: 2, // digits after point 0 for integers
                        signed: false, // disallow negative
                        thousandsSeparator: '.', // any single char
                        padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                        normalizeZeros: false, // appends or removes zeros at ends
                        radix: ',', // fractional delimiter
                        min: 0,
                        max: 1000000000,
                      },
                    }}
                    lazy={false}
                    value={editProductData.contratoEP_vlr}
                    onAccept={value => this.setState({
                      editProductData: {
                        ...editProductData,
                        contratoEP_vlr: value,
                      },
                    })}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Prazo de pagamento
                  </Label>
                  <Input
                    value={editProductData?.contratoEP_prazo}
                    onChange={e => this.setState({
                      editProductData: {
                        ...editProductData,
                        contratoEP_prazo: e.target.value || null,
                      },
                    })}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data de pagamento prevista
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={editProductData?.contratoEP_dtPrev ? moment(editProductData.contratoEP_dtPrev).toDate() : null}
                    onChange={date => this.setState({
                      editProductData: {
                        ...editProductData,
                        contratoEP_dtPrev: date,
                        contratoEP_dtPrev_Invalid: false,
                      },
                    })}
                  />
                </FormGroup>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.setState({ editProductData: {}, editProductModalIsOpen: false })}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => this.handleEditProduct()}
              disabled={
                !editProductData?.contratoProd_desc
                || !editProductData?.contratoProd_prazo
                || !editProductData?.contratoProd_dtPrev
                || (editProductData.hasPaymentEvent && (!editProductData?.contratoEP_vlr || !editProductData?.contratoEP_prazo || !editProductData?.contratoEP_dtPrev))
              }
            >
              Salvar
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          centered={false}
          isOpen={addPaymentModalIsOpen}
          toggle={() => this.setState({ addPaymentData: {}, addPaymentModalIsOpen: false })}
        >
          <ModalHeader
            toggle={() => this.setState({
              addPaymentData: {},
              addPaymentModalIsOpen: false,
            })}
          >
            Adicionar evento de pagamento
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                Tipo
              </Label>

              <AsyncSelect
                cacheOptions
                defaultOptions
                isSearchable={false}
                isClearable={false}
                isMulti={false}
                getOptionValue={option => option.recTp_id}
                getOptionLabel={option => option.recTp_nome}
                value={addPaymentData.recTp_id}
                loadOptions={async () => {
                  try {
                    const res = await oikosApi.get('/', {
                      action: 'get',
                      table: 'recTp',
                    })

                    if (addPaymentData.recTp_id !== undefined) {
                      this.setState(prevState => ({
                        addPaymentData: {
                          ...prevState.addPaymentData,
                          recTp_id: res.data.find(i => i.recTp_id === addPaymentData.recTp_id),
                        },
                      }))
                    }

                    return res.data.filter(item => item.recTp_nome !== 'Produto')
                  } catch (e) {
                    return notifyError(e)
                  }
                }}
                onChange={e => this.setState(prevState => ({
                  addPaymentData: {
                    ...prevState.addPaymentData,
                    recTp_id: e,
                  },
                }))}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                Descrição
              </Label>
              <Input
                value={addPaymentData?.contratoEP_desc}
                onChange={e => this.setState({
                  addPaymentData: {
                    ...addPaymentData,
                    contratoEP_desc: e.target.value || null,
                  },
                })}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                Valor
              </Label>
              <MaskedInput
                unmask
                mask="R$ num"
                blocks={{
                  num: {
                    mask: Number,
                    scale: 2, // digits after point 0 for integers
                    signed: false, // disallow negative
                    thousandsSeparator: '.', // any single char
                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                    normalizeZeros: false, // appends or removes zeros at ends
                    radix: ',', // fractional delimiter
                    min: 0,
                    max: 1000000000,
                  },
                }}
                lazy={false}
                value={addPaymentData.contratoEP_vlr}
                onAccept={value => this.setState({
                  addPaymentData: {
                    ...addPaymentData,
                    contratoEP_vlr: value,
                  },
                })}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                Prazo de pagamento
              </Label>
              <Input
                value={addPaymentData?.contratoEP_prazo}
                onChange={e => this.setState({
                  addPaymentData: {
                    ...addPaymentData,
                    contratoEP_prazo: e.target.value || null,
                  },
                })}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                Data de pagamento prevista
              </Label>

              <DatePicker
                placeholderText="__/__/_____"
                locale="pt-BR"
                className="form-control"
                dateFormat="dd/MM/yyyy"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={addPaymentData?.contratoEP_dtPrev ? moment(addPaymentData.contratoEP_dtPrev).toDate() : null}
                onChange={date => this.setState({
                  addPaymentData: {
                    ...addPaymentData,
                    contratoEP_dtPrev: date,
                    contratoEP_dtPrev_Invalid: false,
                  },
                })}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              onClick={() => this.setState({ addPaymentData: {}, addPaymentModalIsOpen: false })}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => this.handleAddPayment()}
              disabled={
                !addPaymentData?.contratoEP_desc
                || !addPaymentData?.recTp_id
                || !addPaymentData?.contratoEP_prazo
                || !addPaymentData?.contratoEP_vlr
                || !addPaymentData?.contratoEP_dtPrev
                || (addPaymentData?.recTp_id?.recTp_nome === 'Produto' && !addPaymentData?.product)
              }
            >
              Adicionar
            </Button>
          </ModalFooter>
        </Modal>

        <Modal
          centered
          isOpen={deleteProductModalIsOpen}
          toggle={() => this.setState({ deleteProductModalIsOpen: false })}
        >
          <ModalHeader
            toggle={() => this.setState({ deleteProductModalIsOpen: false })}
          >
            Excluir produto
          </ModalHeader>
          <ModalBody>
            Não foi possível excluir, pois há ao menos um Evento de Pagamento vinculado à este Produto.
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="light"
              className="waves-effect waves-light"
              onClick={() => this.setState({ deleteProductModalIsOpen: false })}
            >
              OK
            </Button>
          </ModalFooter>
        </Modal>
      </>
    )
  }
}

const mapStateToProps = state => ({
  comercial: state.comercial,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getLegalEntities,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(AddContract)
